import { useTranslation } from 'react-i18next';
import { SttFormSelect } from '../all';

type Props = {
    grid?: boolean;
    name: string;
    caption?: string;
    defVal?: string;
    onChange: (value: { name: string; value: unknown }) => void;
    [key: string]: unknown;
};

/**
 * Select interval
 *
 * 1 day, 2 day, 1 hour, 2 hour, etc...
 *
 */
export function SttFormInterval({
    grid = false,
    name,
    caption,
    defVal,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const intervals = [
        { id: '0000-00-00 00:00:00', label: t('0000-00-00 00:00:00') },
        { id: '0000-00-00 01:00:00', label: t('0000-00-00 01:00:00') },
        { id: '0000-00-00 02:00:00', label: t('0000-00-00 02:00:00') },
        { id: '0000-00-00 03:00:00', label: t('0000-00-00 03:00:00') },
        { id: '0000-00-00 04:00:00', label: t('0000-00-00 04:00:00') },
        { id: '0000-00-01 00:00:00', label: t('0000-00-01 00:00:00') },
        { id: '0000-00-02 00:00:00', label: t('0000-00-02 00:00:00') },
        { id: '0000-00-03 00:00:00', label: t('0000-00-03 00:00:00') },
        { id: '0000-00-04 00:00:00', label: t('0000-00-04 00:00:00') },
        { id: '0000-00-05 00:00:00', label: t('0000-00-05 00:00:00') },
        { id: '0000-00-06 00:00:00', label: t('0000-00-06 00:00:00') },
        { id: '0000-00-07 00:00:00', label: t('0000-00-07 00:00:00') },
        { id: '0000-00-14 00:00:00', label: t('0000-00-14 00:00:00') },
        { id: '0000-00-21 00:00:00', label: t('0000-00-21 00:00:00') },
        { id: '0000-01-00 00:00:00', label: t('0000-01-00 00:00:00') },
        { id: '0000-02-00 00:00:00', label: t('0000-02-00 00:00:00') },
        { id: '0000-03-00 00:00:00', label: t('0000-03-00 00:00:00') },
        { id: '0000-04-00 00:00:00', label: t('0000-04-00 00:00:00') },
        { id: '0000-05-00 00:00:00', label: t('0000-05-00 00:00:00') },
        { id: '0000-06-00 00:00:00', label: t('0000-06-00 00:00:00') },
    ];

    // Render
    return (
        <SttFormSelect
            grid={grid}
            name={name}
            caption={caption || t('Interval')}
            defVal={defVal}
            onChange={onChange as any}
            options={intervals}
            {...rest}
        />
    );
}
